const message = {
  moreInformation: "Do you need more info?<br> <span class='text-green'>  Get in contact</span> with us",
  send: "Send",
  firstName: "First name and last name",
  email: "Email",
  message: "Message",
  alertSuccess: "Message send successfully.",
};

export default message;